import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import LoadingButton from "@mui/lab/LoadingButton";
import Alert from "@mui/material/Alert";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../../config/apiConfig";

export function ForgotVOtpPage() {
  const navigate = useNavigate();
  const [otp, setOTP] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // Submit form
  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage(""); // Clear any previous error messages

    const email = localStorage.getItem("user_email");

    if (!email) {
      setLoading(false);
      setErrorMessage("User email not found. Please go back and try again.");
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL}/api/user/auth/verify-reset-otp`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email, otp }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        navigate("/updatepassword"); // Navigate to the password recovery page on success
      } else {
        const errorData = await response.json();
        setErrorMessage(
          errorData.message || "OTP verification failed. Please try again."
        );
      }
    } catch (error) {
      setErrorMessage("An unexpected error occurred. Please try again later.");
      console.error("Error during OTP verification:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "linear-gradient(to right, #f8fafc, #edf2fb)",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 400,
          padding: 4,
          boxShadow: 3,
          borderRadius: 2,
          backgroundColor: "#fff",
        }}
      >
        <Typography variant="h5" align="center" gutterBottom>
          Verify OTP
        </Typography>
        <Typography variant="body2" align="center" sx={{ mb: 3 }}>
          Please enter the OTP sent to your email
        </Typography>

        {errorMessage && (
          <Alert severity="error" sx={{ mb: 3 }}>
            {errorMessage}
          </Alert>
        )}

        <Box
          component="form"
          onSubmit={handleVerifyOTP}
          display="flex"
          flexDirection="column"
        >
          <TextField
            fullWidth
            name="verifyOtpPage"
            label="Enter OTP"
            InputLabelProps={{ shrink: true }}
            value={otp}
            onChange={(e) => setOTP(e.target.value)}
            sx={{ mb: 3 }}
            variant="outlined"
          />

          <LoadingButton
            fullWidth
            size="large"
            type="submit"
            variant="contained"
            loading={loading}
            sx={{
              backgroundColor: "#51833a",
              color: "#fff",
              mb: 2,
              textTransform: "none",
              "&:hover": {
                backgroundColor: "#4a7a32",
              },
            }}
          >
            Verify
          </LoadingButton>
        </Box>
      </Box>
    </Box>
  );
}

export default ForgotVOtpPage;
